import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import Cookies from 'js-cookie';
import { jwtDecode } from 'jwt-decode';
import * as pdfjsLib from 'pdfjs-dist/build/pdf';
import 'pdfjs-dist/build/pdf.worker.entry';
import nequiButImg from './nequi_but.png';





function NequiPaymentModal({ onClose }) {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50">
      <div className="bg-white rounded-2xl shadow-2xl p-6 max-w-sm text-center mx-4">
        <h2 className="text-xl font-semibold text-pink-600 mb-3">Confirm your Nequi payment 💜</h2>
        <p className="text-gray-700 mb-3">
          1️⃣ Open your <b>Nequi</b>.<br />
          2️⃣ Go to <b>Notifications</b> or <b>Pending Requests</b>.<br />
          3️⃣ Approve the payment request for the indicated amount.<br />
          4️⃣ Then please return to this page.  
        </p>
        <p className="text-gray-600 text-sm mb-5">
          If you don't see the notification immediately, refresh your app or check your pending requests and payment history.
        </p>
        <button
          onClick={onClose}
          className="bg-pink-600 text-white px-6 py-2 rounded-xl hover:bg-pink-700 transition"
        >
          Got it
        </button>
      </div>
    </div>
  );
}


const PAYPAL_CLIENT_ID = 'AV5oP5MBGfT_68ZhP-kWWuj_-aD94fzUEcojIb1LeVChvxZqAoOs1zrFJYe4u4sAlvXSYLj5TRlAuNcw';

const PLAN_INFO_URL =
  "https://2zyff5s6kpf3ur3otnbqellaby0wkoby.lambda-url.us-east-1.on.aws/";

const PAYPAL_LAMBDA_URL =
  "https://uuyej67fzqonaixlomhzrzzz2m0brlts.lambda-url.us-east-1.on.aws/";



const planesSuscripcion = [
  {
    name: 'Plan Básico',
    duration: 'monthly',
    pages: 500,
    price_cop: 22500,
    precio_por_pagina: 45,
  },
  {
    name: 'Plan Intermedio',
    duration: 'monthly',
    pages: 2000,
    price_cop: 80000,
    precio_por_pagina: 40,
  },
  {
    name: 'Plan Avanzado',
    duration: 'monthly',
    pages: 5000,
    price_cop: 175000,
    precio_por_pagina: 35,
  },
  {
    name: 'Plan Empresarial',
    duration: 'monthly',
    pages: 12000,
    price_cop: 360000,
    precio_por_pagina: 30,
  },

  {
    name: 'Plan Básico',
    duration: 'annual',
    pages: 6000,
    price_cop: 189000,
    precio_por_pagina: 31.5,
  },
  {
    name: 'Plan Intermedio',
    duration: 'annual',
    pages: 24000,
    price_cop: 672000,
    precio_por_pagina: 28,
  },
  {
    name: 'Plan Avanzado',
    duration: 'annual',
    pages: 60000,
    price_cop: 1470000,
    precio_por_pagina: 24.5,
  },
  {
    name: 'Plan Empresarial',
    duration: 'annual',
    pages: 144000,
    price_cop: 3024000,
    precio_por_pagina: 21,
  },
];

const translatePlanName = (name) => {

  if (name === "Plan Básico")
    return "Basic Plan";

  if (name === "Plan Intermedio")
    return "Intermediate Plan";

  if (name === "Plan Avanzado")
    return "Advanced Plan";

  if (name === "Plan Empresarial")
    return "Business Plan";

  return name;
};




function ExtractTextPageLogin() {
  const [pdfPreview, setPdfPreview] = useState(null);
  const [loading, setLoading] = useState(false);
  const [userEmail, setUserEmail] = useState(null);
  const [extractionEnabled, setExtractionEnabled] = useState(false);
  const [pageCount, setPageCount] = useState(null);
  const [selectedOption, setSelectedOption] = useState(null);
  const [waitingNequi, setWaitingNequi] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { fileURL, pages } = location.state || {};
  const paypalRendered = useRef(false);
  const [nequiPhone, setNequiPhone] = useState('');
  const [transactionId, setTransactionId] = useState(null);
  const [checkingStatus, setCheckingStatus] = useState(false);
  const [pushSent, setPushSent] = useState(false);
  const [canCheckStatus, setCanCheckStatus] = useState(false);
  const [showNequiModal, setShowNequiModal] = useState(false);
  const [planInfo, setPlanInfo] =
    useState(null);
  const now = Date.now();

  const isTrial =
    planInfo?.plan_type === "TRIAL";

  const trialExpired =
    isTrial &&
    planInfo?.expires_at &&
    Number(planInfo.expires_at) <= now;

  const trialHasPages =
    isTrial &&
    Number(planInfo?.extra_pages || 0) > 0;

  const canUseTrial =
    trialHasPages &&
    !trialExpired;

  const isPaidPlan =
    !!planInfo?.plan_type &&
    planInfo.plan_type !== "TRIAL";

  const paidPlanActive =
    isPaidPlan &&
    planInfo?.status === "ACTIVE" &&
    (
      !planInfo?.expires_at ||
      Number(planInfo.expires_at) > now
    );

  const hasPlanPages =
    paidPlanActive &&
    Number(planInfo?.plan_pages || 0) > 0;


  const hasPaidExtraPages =
    planInfo?.plan_type === "PAY_PER_USE_PAYPAL" &&
    Number(planInfo?.extra_pages || 0) > 0;


  const hasAvailablePages =
    canUseTrial ||
    hasPlanPages ||
    hasPaidExtraPages;

  
  


  useEffect(() => {
    const idToken = Cookies.get('idToken');
    if (!idToken) return navigate('/login');
    try {
      const decoded = jwtDecode(idToken);
      setUserEmail(decoded.email);
    } catch (err) {
      navigate('/login');
    }
  }, [navigate]);

  const fetchPlanInfo =
    async () => {

    try {

      const token =
        Cookies.get(
          "accessToken"
        );

      const res =
        await axios.get(
          PLAN_INFO_URL,
          {
            headers: {
              Authorization:
                `Bearer ${token}`,
            },
          }
        );

      setPlanInfo(res.data);

    } catch (err) {

      console.error(
        "Error plan info:",
        err
      );
    }
  };

  useEffect(() => {

    fetchPlanInfo();

  }, []);

  useEffect(() => {
    if (!fileURL) navigate('/');
    else {
      setPdfPreview(fileURL);
      if (pages) setPageCount(pages);
      else countPDFPages(fileURL);
    }
  }, [fileURL, pages, navigate]);

  useEffect(() => {
    if (!waitingNequi || !transactionId) return;

    const interval = setInterval(() => {
      checkPaymentStatus();
    }, 5000);

    return () => clearInterval(interval);
  }, [waitingNequi, transactionId]);




  const countPDFPages = async (pdfUrl) => {
    try {
      const pdf = await pdfjsLib.getDocument(pdfUrl).promise;
      setPageCount(pdf.numPages);
    } catch {
      setPageCount(null);
    }
  };

  const extractFileKey = (url) => {
    try {
      const urlObj = new URL(url);
      return decodeURIComponent(urlObj.pathname.split('/').slice(2).join('/'));
    } catch {
      return null;
    }
  };

  

  const handlePagoPorPaginaNequi = () => {
    if (!pageCount) return alert('No se pudo obtener el número de páginas.');

    const getPricePerPage = (pages) => {

      if (pages >= 1000) return 35;
      if (pages >= 500) return 40;
      if (pages >= 100) return 45;

      return 50;
    };

    const pricePerPage =
      getPricePerPage(pageCount);

    const totalPriceCOP =
      (pageCount * pricePerPage)
        .toString();
    setSelectedOption({
      name: 'Pay per Page (Nequi)',
      price: totalPriceCOP,
      pages: pageCount,
      currency: 'COP',
      type: 'PAY_PER_PAGE' // 🔥 CLAVE
    });
  };

  const handlePagoPorPaginaPaypal = () => {

    setSelectedOption({

      name: "Pay per Page (PayPal)",

      price: "0.60",

      pages: 20,

      

      currency: "USD",

      type: "PAY_PER_PAGE"

    });

  };

  const handlePlanSeleccionado = (
    plan,
    metodo = "nequi"
  ) => {

    setSelectedOption({
      ...plan,

      currency:
        metodo === "paypal"
          ? "USD"
          : "COP",

      type: "PLAN"
    });
  };

  const parseJwt = (token) => {
    try {
      return JSON.parse(
        atob(token.split('.')[1])
      );
    } catch (e) {
      return null;
    }
  };


  useEffect(() => {

    if (
      !selectedOption ||
      selectedOption.currency !== "USD"
    ) {
      return;
    }

    paypalRendered.current = false;

    const existingScript =
      document.querySelector(
        'script[src*="paypal.com/sdk/js"]'
      );

    if (!existingScript) {

      const script =
        document.createElement("script");

      script.src =
        `https://www.paypal.com/sdk/js?client-id=${PAYPAL_CLIENT_ID}`;

      script.async = true;

      script.onload =
        renderPaypalButtons;

      document.body.appendChild(
        script
      );

    } else {

      renderPaypalButtons();
    }

    async function renderPaypalButtons() {

      if (
        paypalRendered.current ||
        !window.paypal
      ) {
        return;
      }

      paypalRendered.current = true;

      document.getElementById(
        "paypal-button-container"
      ).innerHTML = "";

      window.paypal.Buttons({

        createOrder: async () => {

          const token =
            Cookies.get(
              "accessToken"
            );

          const response =
            await axios.post(
              PAYPAL_LAMBDA_URL,
              {
                action:
                  "createOrder",

                payment_type:
                  selectedOption.type,

                pages:
                  selectedOption.pages,

                pages_available:
                  selectedOption.pages,

                plan_type:
                  selectedOption.name,

                amount:
                  selectedOption.price
              },
              {
                headers: {
                  Authorization:
                    `Bearer ${token}`
                }
              }
            );

          return response.data.orderId;
        },

        onApprove: async (
          data
        ) => {

          const token =
            Cookies.get(
              "accessToken"
            );

          const response =
            await axios.post(
              PAYPAL_LAMBDA_URL,
              {
                action:
                  "captureOrder",

                orderId:
                  data.orderID,

                payment_type:
                  selectedOption.type,

                pages:
                  selectedOption.pages,

                pages_available:
                  selectedOption.pages,

                plan_type:
                  selectedOption.name
              },
              {
                headers: {
                  Authorization:
                    `Bearer ${token}`
                }
              }
            );

          if (
              response.data.status ===
              "COMPLETED"
            ) {

              setTransactionId(
                response.data.orderId
              );

              await fetchPlanInfo();

              setExtractionEnabled(
                true
              );

              alert(
                "✅ Payment approved"
              );
            }
        },

        onError: (err) => {

          console.error(err);

          alert(
            "Error processing PayPal payment"
          );
        }

      }).render(
        "#paypal-button-container"
      );
    }

  }, [selectedOption]);

  const handleNequiPayment = async () => {
    const accessToken = Cookies.get("accessToken");
    if (!selectedOption) {
      alert("Please select a plan or pay-per-page option");
      return;
    }
    if (!nequiPhone || nequiPhone.length !== 10) {
      alert("Invalid Nequi phone number");
      return;
    }

    try {
      setWaitingNequi(true);
      setShowNequiModal(true);

      const isPlan =
        selectedOption?.type === "PLAN";

      let payload;

      if (isPlan) {
        payload = {
          plan_type: selectedOption.name,
          pages_available: selectedOption.pages,
          payment_method: "nequi",
          phoneNumber: nequiPhone,
          payment_value: Number(selectedOption.price),
        };
      } else {
        payload = {
          payment_method: "nequi",
          phoneNumber: nequiPhone,
          payment_value: Number(selectedOption.price),
          pages: selectedOption.pages
        };
      }

      

      const res = await axios.post(
        "https://jb4ogkdasqbrkiefenygi3tzyy0vnwcg.lambda-url.us-east-1.on.aws/",
        payload,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
        }
      );

      setTransactionId(res.data.transactionId);
      

      

      alert("📲 Payment request sent to your Nequi app");
      
      setPushSent(true);
      setCanCheckStatus(false);

      setTimeout(() => {
        setCanCheckStatus(true);
      }, 6000); // 6 segundos reales para que Nequi procese



    } catch (err) {
      console.error(err);
      alert("Error sending Nequi payment");
      setWaitingNequi(false);
    }
  };

  /* =========================
     Pago Nequi (ESTADO)
  ========================= */
 const checkPaymentStatus = async () => {
  if (!transactionId) {
    alert("No hay transacción");
    return;
  }
  if (transactionId.startsWith("TEST_")) {
    console.log("🧪 SANDBOX FRONT: pago aprobado automático");

    await fetchPlanInfo();
    setExtractionEnabled(true);
    setWaitingNequi(false);
    setShowNequiModal(false);
    setPushSent(false);
    setNequiPhone('');

    return;
  }

  try {
    setCheckingStatus(true);

    const token = Cookies.get("accessToken");
    const idToken = Cookies.get("idToken");

    const payload = parseJwt(idToken);
    const email = payload?.email;

    if (!email) {
      alert("No se pudo obtener el email del usuario");
      return;
    }

    const res = await fetch(
      "https://oy65sm3fdom2u5ot3gk5xez7we0otgnr.lambda-url.us-east-1.on.aws/",
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          transactionId,
          email, // ✅ AHORA SÍ
        }),
      }
    );

    const data = await res.json();

    if (!res.ok) {
      console.error("Error Lambda:", data);
      alert(data.error || "Error consultando estado");
      return;
    }

    const estado =
      data.estado ||
      data.nequiPushResult?.status ||
      data.nequiPushResult?.state;

    if (!estado) {
      console.log("⏳ Aún sin estado definitivo:", data);
      
      return;
    }

    if (estado === "APPROVED") {
      await fetchPlanInfo();
      alert("✅ Payment approved");
      setExtractionEnabled(true);
      setWaitingNequi(false);
      setCanCheckStatus(false);
      setShowNequiModal(false); 
      setPushSent(false);
      setNequiPhone('');
    } else if (estado === "PENDING") {
      console.log("⏳ Aún pendiente en Nequi");
    } else if (estado === "REJECTED") {
      alert("❌ Payment rejected");
      setWaitingNequi(false);
    } else if (estado === "EXPIRED") {
      alert("⌛ Payment expired");
      setWaitingNequi(false);
    }
  } catch (err) {
    console.error(err);
    alert("Error checking payment status");
  } finally {
    setCheckingStatus(false);
  }
};





const handleExtractText = async () => {
  if (
  !extractionEnabled &&
  !hasAvailablePages
  ) return alert('You must complete a payment before extracting the text.');
  setLoading(true);

  try {
    if (!pageCount) {
      throw new Error("Unable to determine the number of pages");
    }

    const key = extractFileKey(fileURL);
    if (!key) throw new Error('Unable to retrieve the file key.');

    const fileNameOnly = key.split('/').pop();

    const usingTrial =
      canUseTrial;

    const usingPaidPlan =
      hasPlanPages;

    const usingPaidExtraPages =
      hasPaidExtraPages;

    const usingAccountPages =
      usingTrial ||
      usingPaidPlan ||
      usingPaidExtraPages;

    const isPlan =
      selectedOption?.type === "PLAN" ||
      usingAccountPages;

    if (!isPlan &&!transactionId) {
      throw new Error("No transaction ID available");
    }

   

    let payload;

    if (isPlan) {
      payload = {
        fileName: fileNameOnly,
        payment_mode: "PLAN",
        pages: pageCount
      };
    } else {
      payload = {
        fileName: fileNameOnly,
        payment_mode: "PAY_PER_PAGE",
        transaction_id: transactionId,
        pages: pageCount
      };
    }

    console.log("Sending:", payload);

    const response = await axios.post(
      'https://yi2dgtfdembaun6bmdpvcgxbku0nyjsq.lambda-url.us-east-1.on.aws/',
      payload,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${Cookies.get('accessToken')}`,
        },
      }
    );

    const data = response.data.body ? JSON.parse(response.data.body) : response.data;

    if (!data.txtDownloadUrl) throw new Error('Download URL was not received');

    await fetchPlanInfo();
    
    navigate('/downloadtextpagelogin', {
      state: {
        email: userEmail,
        fileKey: key,
        txtDownloadUrl: data.txtDownloadUrl,
        docDownloadUrl: data.docDownloadUrl,
        pages: data.pages,
      },
    });

  } catch (err) {
    console.error(err);
    alert(err.message || 'Error during text extraction');
  } finally {
    setLoading(false);
  }
};



  const planesNequi = planesSuscripcion.map(plan => ({
    name: `${translatePlanName(plan.name)} (${plan.duration === 'monthly' ? 'Monthly' : 'Annual'})`,
    price: plan.price_cop,
    priceLabel: plan.price_cop.toLocaleString(),
    pages: plan.pages,
    precio_por_pagina: +(plan.price_cop / plan.pages).toFixed(1),
    type: 'PLAN' // 🔥 AÑADE ESTO
  }));


  const planesPaypal =
    planesSuscripcion.map(plan => {

      const priceUSD =
        Number(
          (plan.price_cop / 3500)
            .toFixed(4)
        );

      return {

        name:
          `${translatePlanName(plan.name)}
          (${plan.duration === 'monthly'
            ? 'Monthly'
            : 'Annual'})`,

        price: priceUSD,

        pages: plan.pages,

        pricePerPage:
          (
            priceUSD /
            plan.pages
          ).toFixed(4)
      };
    });

  // 🔍 Verificar estado real del pago en Nequi





  return (
  <div className="p-6 md:p-10 max-w-7xl mx-auto text-center">
    <h1 className="text-3xl md:text-4xl font-bold text-blue-600 mb-8">
      Text Extraction from PDF
    </h1>

    {hasAvailablePages ? (

      <div className="bg-gradient-to-r from-blue-50 to-indigo-50 border border-blue-200 rounded-2xl p-6 mb-8 shadow">

        <h2 className="text-2xl font-bold text-blue-900 mb-3">

          {canUseTrial
            ? "🎁 Active Free Trial"
            : hasPlanPages
              ? `📦 Active ${planInfo.plan_type} Plan`
              : hasPaidExtraPages
                ? "💳 Paid Pages Available"
                : trialExpired
                  ? "⚠️ Free Trial Expired"
                  : "💳 Payment Required"}

        </h2>

        <div className="text-gray-700 space-y-2">

          {planInfo.plan_pages > 0 && (
              <p>
                Plan Pages:
                <strong>
                  {" "}
                  {planInfo.plan_pages}
                </strong>
              </p>
            )}

            {canUseTrial && (
              <p>
                Free Trial Pages:
                <strong>
                  {" "}
                  {planInfo.extra_pages}
                </strong>
              </p>
            )}

            {hasPaidExtraPages && (
              <p>
                Paid Pages:
                <strong>
                  {" "}
                  {planInfo.extra_pages}
                </strong>
              </p>
            )}

          <p>
            Status:
            <strong>
              {" "}
              {planInfo.status}
            </strong>
          </p>

          <p>
            Expires:
            <strong>
              {" "}
              {planInfo?.expires_at
                ? new Date(
                    Number(planInfo.expires_at)
                  ).toLocaleDateString()
                : "N/A"}
            </strong>
          </p>

        </div>

        <div className="mt-5 text-green-700 font-semibold text-lg">

          ✅ Your subscription is active and ready to use.

        </div>

      </div>

    ) : (

    <>

    <div className="flex flex-col md:flex-row justify-center gap-4 mb-8">
    {/* PayPal */}
      <button
        onClick={handlePagoPorPaginaPaypal}
        className="bg-blue-600 text-white px-6 py-3 rounded-xl shadow hover:bg-blue-700 transition"
      >
        Pay per Use (PayPal)

        <span className="block text-xs mt-2 font-normal">

          Minimum purchase
          <br />

          Includes 20 pages

        </span>

        <span className="block text-sm font-normal mt-2">

          $0.60 USD

        </span>

      </button>
     {/* Nequi */}
      <button
        onClick={handlePagoPorPaginaNequi}
        className="bg-pink-500 text-white px-6 py-3 rounded-xl shadow hover:bg-pink-600 transition"
      >
        Pay per Page with Nequi

        <span className="block text-xs mt-2 font-normal">

          50 COP/page (1–99)
          <br />

          45 COP/page (100–499)
          <br />

          40 COP/page (500–999)
          <br />

          35 COP/page (1000+)

        </span>

        {pageCount && (
          <span className="block text-sm font-normal mt-1">

            {(() => {

              const getPricePerPage =
                (pages) => {

                if (pages >= 1000)
                  return 35;

                if (pages >= 500)
                  return 40;

                if (pages >= 100)
                  return 45;

                return 50;
              };

              const ppp =
                getPricePerPage(
                  pageCount
                );

              return (
                <>
                  {ppp} COP per page
                  <br />
                  Total:
                  {" "}
                  ${(pageCount * ppp)
                    .toLocaleString()}
                  {" "}
                  COP
                  {" "}
                  ({pageCount} page{pageCount !== 1 ? 's' : ''})
                </>
              );
            })()}

          </span>
        )}

      </button>

      

    </div>

    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
      <div className="bg-white shadow-md rounded-xl p-6">

        <h2 className="text-xl font-semibold text-blue-600 mb-6">
          PayPal Plans
        </h2>

        <div className="grid gap-4">

          {planesPaypal.map((plan, index) => {

            const destacado =
              plan.pages === 2000;

            return (

              <div
                key={index}
                className={`border rounded-xl p-5 transition
                  ${
                    destacado
                      ? 'border-blue-500 bg-blue-50 shadow-lg'
                      : 'border-gray-200 bg-white'
                  }
                `}
              >

                {destacado && (

                  <div className="text-xs font-semibold text-blue-600 mb-2">

                    ⭐ MOST POPULAR

                  </div>

                )}

                <div className="text-lg font-semibold text-gray-800">

                  {plan.name}

                </div>

                <div className="text-sm text-gray-600 mb-2">

                  {plan.pages.toLocaleString()}
                  {" "}
                  Included Pages

                </div>

                <div className="text-2xl font-bold text-gray-900 mb-1">

                  ${plan.price} USD

                </div>

                <div className="text-sm text-gray-700 mb-4">

                  Price per Page:
                  {" "}
                  <b>

                    $
                    {(plan.price / plan.pages)
                      .toFixed(4)}

                  </b>

                </div>

                <button

                  onClick={() =>
                    handlePlanSeleccionado(
                      plan,
                      "paypal"
                    )
                  }

                  className={`
                    w-full py-2 rounded-lg font-semibold transition
                    ${
                      destacado
                        ? "bg-blue-600 text-white hover:bg-blue-700"
                        : "bg-gray-800 text-white hover:bg-gray-900"
                    }
                  `}
                >

                  Choose Plan

                </button>

              </div>
            );
          })}
        </div>
      </div>

      <div className="bg-white shadow-md rounded-xl p-6">
        <h2 className="text-xl font-semibold text-pink-600 mb-6">
          Nequi Plans
        </h2>

        <div className="grid gap-4">
          {planesNequi.map((plan, index) => {
            const destacado = plan.name.includes('Intermediate') && plan.name.includes('Monthly');

            return (
              <div
                key={index}
                className={`border rounded-xl p-5 transition
                  ${destacado
                    ? 'border-pink-500 bg-pink-50 shadow-lg'
                    : 'border-gray-200 bg-white'}
                `}
              >
                {destacado && (
                  <div className="text-xs font-semibold text-pink-600 mb-2">
                    ⭐ MOST POPULAR
                  </div>
                )}

                <div className="text-lg font-semibold text-gray-800">
                  {plan.name}
                </div>

                <div className="text-sm text-gray-600 mb-2">
                  {plan.pages.toLocaleString()} Included Pages
                </div>

                <div className="text-2xl font-bold text-gray-900 mb-1">
                  ${plan.priceLabel} COP
                </div>

                <div className="text-sm text-gray-700 mb-4">
                  Price per Page: <b>{plan.precio_por_pagina} COP</b>
                </div>

                <button
                 
                  onClick={() => handlePlanSeleccionado(plan)}
                  className={`w-full py-2 rounded-lg font-semibold transition
                    ${destacado
                      ? 'bg-pink-600 text-white hover:bg-pink-700'
                      : 'bg-gray-800 text-white hover:bg-gray-900'}
                  `}
                >
                  Choose Plan
                </button>
              </div>
            );
          })}
        </div>
      </div>


      </div>
      </>
    )}

    {selectedOption?.currency === 'COP' && (
      <>
        {showNequiModal && waitingNequi && (
          <NequiPaymentModal onClose={() => setShowNequiModal(false)} />
        )}

        {waitingNequi ? (
          <p className="text-yellow-600 font-semibold mt-4">
            Waiting for confirmation from your Nequi App...
            <br />
            Please follow the instructions in the pop-up window.
          </p>
        ) : (
          <div className="flex flex-col items-center gap-4">
            <input
              type="text"
              placeholder="Enter your Nequi phone number"
              value={nequiPhone}
              maxLength={10}
              onChange={(e) => setNequiPhone(e.target.value.replace(/\D/g, ''))}
              className="border border-gray-300 p-3 rounded-xl text-center w-64 focus:ring focus:ring-pink-300"
            />

            <button
              onClick={handleNequiPayment}
              disabled={waitingNequi}
              className="transition hover:opacity-90"
            >
              <img
                src={nequiButImg}
                alt="Nequi Payment Button"
                className="mx-auto w-52 md:w-64"
              />
            </button>

            <button
              onClick={checkPaymentStatus}
              disabled={!transactionId || checkingStatus || !canCheckStatus}
              className="w-full px-4 py-3 mt-3 bg-blue-500 text-white rounded-xl hover:bg-blue-600 disabled:bg-gray-400"
            >
              {checkingStatus ? "Checking..." : "🔄 Check Payment Status"}
            </button>
          </div>
        )}
      </>
    )}

    {selectedOption?.currency === 'USD' && (

      <div className="mt-8">

        <div
          id="paypal-button-container"
          className="max-w-md mx-auto"
        />

      </div>

    )}

    <div className="mt-10">
      <button
        onClick={handleExtractText}
        disabled={
          (
            !extractionEnabled &&
            !hasAvailablePages
          ) || loading
        }
        className={`w-full md:w-1/2 mx-auto px-6 py-3 rounded-xl font-semibold text-white ${
          loading ||
          (
            !extractionEnabled &&
            !hasAvailablePages
          )
            ? 'bg-gray-400 cursor-not-allowed'
            : 'bg-green-500 hover:bg-green-600'
        } transition`}
      >
        {loading ? 'Extracting text...' : 'Extract Text from PDF'}
      </button>
    </div>
  </div>
);
}


export default ExtractTextPageLogin;


